import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StatsDataPayload {
  flashcardsAnswered: number | null;
  vignettesAnswered: number | null;
  videosWatched: number | null;
  daysStudied: number | null;
  averageFlashcardTime: number | null;
}

const initialState: StatsDataPayload = {
  flashcardsAnswered: null,
  vignettesAnswered: null,
  videosWatched: null,
  daysStudied: null,
  averageFlashcardTime: null,
};

const statsSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    setStatsData: (_state, action: PayloadAction<StatsDataPayload>) => {
      return action.payload;
    },
  },
});

export const { setStatsData } = statsSlice.actions;

export default statsSlice.reducer;
